module.exports = __webpack_public_path__ + "img/temperature.77013918.svg";